import { browserStatics } from "@/src/shared/BrowserStatic";

export async function Post<TResponse, TRequest>(
    url: string,
    { arg }: { arg: TRequest },
    headers?: HeadersInit,
) {
    return await fetch(url, {
        method: "POST",
        body: JSON.stringify(arg),
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Goodie-Origin": "app",
            ...headers,
        },
        mode: "cors",
    }).then((r) => r.json() as TResponse);
}

export const PostAndForget = (url: string, body: object, headers?: HeadersInit, callback?: () => void) => {
    fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Requested-With": "XMLHttpRequest",
            ...headers,
        },
        mode: "cors",
    }).finally(callback);
};

export const FetchRawGet = async (url: string, headers?: HeadersInit) => {
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Accept-Images": browserStatics.imageSupport,
            Accept: "application/json; charset=utf-8",
            "X-Requested-With": "XMLHttpRequest",
            ...headers,
        },
        mode: "cors",
    });

    return await response.text();
};

export const FetchPage = <TResult>(url: string, headers?: HeadersInit) =>
    Fetch<TResult>("GET", url, undefined, headers);
export const FetchGet = <TResult>(url: string, headers?: HeadersInit) =>
    Fetch<TResult>("GET", url, undefined, headers).then((r) => r.body);
export const FetchPost = <TResult>(url: string, body?: object, headers?: HeadersInit) =>
    Fetch<TResult>("POST", url, body, headers).then((r) => r.body);
export const FetchPut = <TResult>(url: string, headers?: HeadersInit) =>
    Fetch<TResult>("PUT", url, undefined, headers);

const Fetch = async <TResult>(
    method: "GET" | "POST" | "PUT",
    url: string,
    reqBody: object,
    headers?: HeadersInit,
) => {
    const { culture } = browserStatics;

    let body: string | undefined = undefined;
    if (reqBody) {
        body = JSON.stringify(reqBody);
        headers = { ...headers, "Content-Type": "application/json; charset=utf-8" };
    }

    const response = await fetch(url, {
        method: method,
        headers: {
            "Accept-Images": browserStatics.imageSupport,
            Accept: "application/json; charset=utf-8",
            "Accept-Language": culture,
            "X-Requested-With": "XMLHttpRequest",
            ...headers,
        },
        mode: "cors",
        body,
    });

    let responseBody: TResult;

    try {
        responseBody = (await response.json()) as TResult;
    } catch (err) {
        console.error(err);
    }

    return { body: responseBody, status: response.status };
};
